// Greeting Helper - Renders the copilot greeting with theme configuration
import CopilotGreeting from '../../../components/CopilotGreeting/CopilotGreeting';
import { getCurrentModeConfig } from './modeConfigs';

/**
 * Converts color string to rgba format
 */
const toRgba = (color, alpha) => {
  if (!color) return undefined;
  if (color.startsWith('rgba(')) return color;
  if (color.startsWith('rgb(')) {
    try {
      const body = color.slice(4, -1);
      return `rgba(${body}, ${alpha})`;
    } catch (_) { 
      return color; 
    }
  }
  return color;
};

/**
 * Renders the copilot greeting with appropriate theme and layout
 * For forecast greeting, examples are informational (not clickable)
 * Users can start typing in the input bar below
 */
export const renderGreeting = (showGreeting, layoutView, onExampleClick) => {
  if (!showGreeting) return null;
  
  const modeConfig = getCurrentModeConfig('general');
  const themeColor = modeConfig.themeColor;
  const themeBg = modeConfig.themeBg || (themeColor ? toRgba(themeColor, 0.12) : undefined);
  const themeBgActive = modeConfig.themeBgActive || (themeColor ? toRgba(themeColor, 0.20) : undefined);
  
  return (
    <CopilotGreeting 
      icon={modeConfig.greeting.icon}
      title={modeConfig.greeting.title}
      subtitle={modeConfig.greeting.subtitle} 
      examples={modeConfig.greeting.examples}
      theme={modeConfig.theme || (themeColor ? 'custom' : 'blue')}
      color={themeColor}
      bg={themeBg}
      bgHover={themeBgActive}
      layout="grid"
      columns={layoutView === 'canvas' ? 1 : 3}
      rows={3}
      onExampleClick={null}
    />
  );
};

